import React from 'react'
  import { DateRangeOutlined, InfoOutlined,  LocalShippingOutlined, Person,  PrintOutlined, TopicOutlined } from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { useComplianceDetailContext } from "contexts/ComplianceDetailContext";

import { localizeDateShort } from "utils/dateFormats";

const ComplianceBasicDetail = () => {

  const { complianceDetail, loadingCompliance } =
    useComplianceDetailContext();
  return !loadingCompliance ? (
    <Box padding={3}>
      <Grid container spacing={4}>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <PrintOutlined color="primary" />}
            title="Customs ID"
            subtitle={complianceDetail?.customsId}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocalShippingOutlined color="primary" />}
            title="Shipment ID"
            subtitle={
              complianceDetail?.shipmentId && typeof complianceDetail.shipmentId === "object"
                ? complianceDetail?.shipmentId?.shipmentId
                : complianceDetail?.shipmentId
            }
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <Person color="primary" />}
            title="CustomerOfficer ID"
            subtitle={complianceDetail?.customsOfficerId}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Clearance Date"
            subtitle={localizeDateShort(complianceDetail?.clearanceDate)}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <TopicOutlined color="primary" />}
            title="Documents"
            subtitle={complianceDetail?.requiredDocuments}
          />
        </Grid>


        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Customs Status"
            subtitle={complianceDetail?.customsStatus}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="isActive"
          >
            <Status isActive={complianceDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  )
}

export default ComplianceBasicDetail